"use client";

import { Analitica, Metadata } from "@stone-payments/analitica";
import { commonEnvs } from "@/config/env";
import { DatadogPlugin } from "@stone-payments/analitica/plugin-datadog";
import {
  AmplitudeClientPlugin,
  type AmplitudeClientExperimentEvent,
  type AmplitudeClientOptions,
} from "@/services/amplitude/plugin";

export const analiticaInstance = new Analitica(
  {
    app: { version: commonEnvs.VERSION, env: commonEnvs.ENV },
    user: {
      id: undefined,
    },
  } as Metadata,
  [
    new AmplitudeClientPlugin(),
    new DatadogPlugin({
      applicationId: commonEnvs.KEY.DATADOG.APPLICATION_ID!,
      clientToken: commonEnvs.KEY.DATADOG.CLIENT_TOKEN!,
      site: "us3.datadoghq.com",
      service: "stone/swh-ecommerce",
      version: commonEnvs.VERSION,
      env: commonEnvs.ENV,
      costCenter: "860290190",
      githubOrg: "stone-payments",
      githubRepo: "swh-ecommerce",
      owner: "swh-frontenders",
      project: "swh-ecommerce",
      support: "swh-frontenders",
      traceSampleRate: 100,
      telemetrySampleRate: 100,
      telemetryConfigurationSampleRate: 100,
      sessionSampleRate: 100,
      sessionReplaySampleRate: commonEnvs.ENV === "production" ? 1 : 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask",
      groupSlack: "swh-help",
    }),
  ],
  { dryRun: !commonEnvs.ANALITICA_ENABLED }
);

function getAmplitudePluginInstance() {
  const amplitudePluginInstance = analiticaInstance.plugins.find(
    (plugin) => plugin.name === "SWH_ECOMMERCE_AMPLITUDE"
  ) as AmplitudeClientPlugin | undefined;

  return amplitudePluginInstance;
}

export function initAmplitudeClient(options: AmplitudeClientOptions) {
  const amplitudePluginInstance = getAmplitudePluginInstance();

  amplitudePluginInstance?.init(options);
}

export function setAmplitudeStoreId(storeId: string) {
  const amplitudePluginInstance = getAmplitudePluginInstance();

  amplitudePluginInstance?.setStoreId(storeId);
}

export function sendExposureEvent(event: AmplitudeClientExperimentEvent) {
  const amplitudePluginInstance = getAmplitudePluginInstance();

  amplitudePluginInstance?.sendExposureEvent(event);
}
